import PropTypes from 'prop-types';
import React from 'react';
import styles from './RefundReasonStyle.css';

class ReceiptRefundReason extends React.Component {
  render() {
    const { invoiceRefund } = this.props;
    return (
      <div className={styles['receipt-refund-reason']}>
        <div className="receipt-returned-goods pull-left">
          Reason for Cancellation
        </div>
        <div className={styles['truncate-refund-reason']}>
          {invoiceRefund.refunded_reason}
        </div>
      </div>
    );
  }
}

ReceiptRefundReason.propTypes = {
  invoiceRefund: PropTypes.object,
};

export default ReceiptRefundReason;
